import cryptoJS from 'crypto-js';
import { VIDEO_CALL } from 'constants/identityMethod';
import { useEffect } from 'react';
import { VIDEO_CALL_CHROME_IOS_FLAG, VIDEO_SELFIE_CHROME_IOS_FLAG } from 'constants/featureFlagging';
import { isValidBrowser } from 'components/newAccountSteps/profileSteps/profileStep3/videocall/videocallHelper';
import { PAGE_PRODUCT, recordEvent, recordIdentityEvent } from 'utilities/uTagging';
import {
    EVENT_ONBOARDING,
    PATH_IDENTITY_VIDEOCALL,
    PATH_IDENTITY_VIDEOCALL_BROWSER_ERROR,
    PATH_IDENTITY_VIDEOCALL_EVENT,
    PATH_IDENTITY_VIDEOSELFIE,
    PATH_IDENTITY_VIDEOSELFIE_BROWSER_ERROR,
    PATH_IDENTITY_VIDEOSELFIE_EVENT,
} from 'constants/uTagConstants/paths';

export const useDoTagging = ({ flags, docNumber, recordId, userId, investmentType, type, withTabs }) => {
    const checkBowserTagError = typeSelected => {
        const realType = typeSelected || type;
        const isRealTypeVideoCall = realType === VIDEO_CALL;
        const videoChromeFlag = isRealTypeVideoCall
            ? flags?.get(VIDEO_CALL_CHROME_IOS_FLAG)
            : flags?.get(VIDEO_SELFIE_CHROME_IOS_FLAG);

        if (!isValidBrowser(videoChromeFlag)) {
            recordIdentityEvent(
                'onboarding',
                isRealTypeVideoCall ? PATH_IDENTITY_VIDEOCALL_EVENT : PATH_IDENTITY_VIDEOSELFIE_EVENT,
                'error/navegador',
                isRealTypeVideoCall ? PATH_IDENTITY_VIDEOCALL_BROWSER_ERROR : PATH_IDENTITY_VIDEOSELFIE_BROWSER_ERROR,
                `navegador no compatible con ${isRealTypeVideoCall ? 'videollamada' : 'videoselfie'}`
            );
        }
    };

    useEffect(() => {
        const isTypeVideoCall = type === VIDEO_CALL;
        if (!withTabs) {
            const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
            recordEvent(
                isTypeVideoCall ? PATH_IDENTITY_VIDEOCALL : PATH_IDENTITY_VIDEOSELFIE,
                PAGE_PRODUCT,
                PATH_IDENTITY_VIDEOCALL_EVENT,
                isTypeVideoCall ? 'videoconferencia' : 'videoselfie',
                recordId,
                userId,
                '',
                investmentType,
                docNumberEncrypted,
                {
                    categoriaEvento: EVENT_ONBOARDING,
                    accionEvento: isTypeVideoCall ? PATH_IDENTITY_VIDEOCALL_EVENT : PATH_IDENTITY_VIDEOSELFIE_EVENT,
                    etiquetaEvento: isTypeVideoCall ? 'videoconferencia' : 'videoselfie',
                }
            );
            checkBowserTagError();
        }
    }, [type, withTabs]);

    return { checkBowserTagError };
};
